export const communityRouteNames = {
  CommunityBoard: 'community/community-board'
}
